import { combineReducers } from 'redux';
import mainContent from './mainContent';
import infoContent from './infoContent';
import swaggerContent from './swaggerContent';
import productList from './productList';
import services from './servicesList';

const productsRootReducer = combineReducers({
  contentType: mainContent,
  infoContent,
  swaggerContent,
  productList,
  services
});

export default productsRootReducer;
